import { shallowEqual } from 'react-redux';
import { thunkRecalculateBombTrajectories } from './bombsActions';
export const CLEAR_GAME_DIMENSIONS_STATE = 'CLEAR_GAME_DIMENSIONS_STATE';
export const SET_STAGE_DIMENSIONS = 'SET_STAGE_DIMENSIONS';
export const SET_IS_SELF_SITTING = 'SET_IS_SELF_SITTING';
export const SET_NUM_AVAILABLE_SEATS = 'SET_NUM_AVAILABLE_SEATS';
export const UPDATE_GAME_DIMENSIONS_FROM_GAME_SETTINGS = 'UPDATE_GAME_DIMENSIONS_FROM_GAME_SETTINGS';
export function clearGameDimensionsState() {
    return {
        type: CLEAR_GAME_DIMENSIONS_STATE
    };
}
function setStageDimensions(dimensions) {
    return {
        type: SET_STAGE_DIMENSIONS,
        payload: dimensions
    };
}
export function thunkSetStageDimensions(dimensions) {
    return function (dispatch, getState) {
        const previousTableAreaDimensions = getState().gameDimensions.tableAreaDimensions;
        // ensure dimensions are round numbers:
        dispatch(setStageDimensions({ w: Math.ceil(dimensions.w), h: Math.ceil(dimensions.h) }));
        const newTableAreaDimensions = getState().gameDimensions.tableAreaDimensions;
        const areTableAreaDimensionsChanging = !shallowEqual(previousTableAreaDimensions, newTableAreaDimensions);
        if (areTableAreaDimensionsChanging) {
            dispatch(thunkRecalculateBombTrajectories());
        }
    };
}
export function setIsSelfSittingForGameDimensions(isSelfSitting) {
    return { type: SET_IS_SELF_SITTING, payload: isSelfSitting };
}
/**
 * These game settings are not expected to change during the life of a room, so they will likely all be set at room init time.
 */
export function updateGameDimensionsFromGameSettings({ numAvailableSeats, isAllInGame }) {
    return { type: UPDATE_GAME_DIMENSIONS_FROM_GAME_SETTINGS, payload: { numAvailableSeats, isAllInGame } };
}
